export const banks = [
    { id: '05', name: 'khan' },
    { id: '15', name: 'golomt' },
    { id: '32', name: 'xac' },
    { id: '34', name: 'state' },
    { id: '04', name: 'tdb' },
    { id: '30', name: 'capitron' },
    { id: '21', name: 'arig' },
    { id: '38', name: 'bogd' },
    { id: '39', name: 'mbank' },
    { id: '19', name: 'tranbank' },
    { id: '29', name: 'nib' },
    { id: '33', name: 'chingis' },
];

export const mccs = [
    { id: '5200', name: '5200' },
    { id: '5811', name: '5811' },
    { id: '7011', name: '7011' },
    { id: '4121', name: '4121' },
    { id: '5532', name: '5532' },
    { id: '5039', name: '5039' },
    { id: '4816', name: '4816' },
    { id: '2741', name: '2741' },
    { id: '5651', name: '5651' },
    { id: '2842', name: '2842' },
    { id: '7230', name: '7230' },
    { id: '8011', name: '8011' },
    { id: '8211', name: '8211' },
    { id: '7276', name: '7276' },
    { id: '6010', name: '6010' },
    { id: '6300', name: '6300' },
    { id: '7032', name: '7032' },
    { id: '9222', name: '9222' },
];

export const formatCurrency = (amount, locale, currency) => {
    if (currency) {
        return new Intl.NumberFormat(locale === 'mn' ? 'mn-MN' : 'en-US', {
            style: 'currency',
            currency,
            minimumFractionDigits: 0,
        }).format(amount);
    }
};

export const formatDate = (date, locale) => {
    return new Intl.DateTimeFormat(locale === 'mn' ? 'mn-MN' : 'en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }).format(date);
};

export const formatDateTime = (dateInput, locale) => {
    if (!dateInput) return "";

    const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (Number.isNaN(d.getTime())) return "";

    return new Intl.DateTimeFormat(locale === "mn" ? "mn-MN" : "en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    }).format(d);
};

